import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'
import { Modal, Modals, ModalSwitch } from 'components/modals'
import { Event, Events, EventSwitch } from 'components/events'
import { AppParallax, AppDrawer } from 'components/layout'
import { Views } from 'components/views'
import { Loading } from 'components/library'
import { AppContext } from 'helpers'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'
import { translate } from 'translations'

class App extends React.Component {
  constructor(props) {
    super(props)

    this.toggleModal = (e, name, data) => {
      this.setState(prevState => {
        if(name && prevState.modal !== name)
          return { modal: name, modalData: data }
        else
          return { modal: false, modalData: {} }
      })
    }

    this.toggleNavigation = status => this.setState(prevState => ({ isNavOpen: !prevState.isNavOpen }))
    this.triggerEvent = name => this.setState({ event: name })
    this.triggerTheme = name => this.setState({ theme: name })
    this.setLocation = location => this.setState({ location: location })
    this.setBackground = (image, style) => this.setState({ background: { image, style }})
    this.willProgress = data => this.setState({ checkProgress: data })
    this.didProgress = () => this.setState({ checkProgress: false })

    this.state = {
      modal: false,
      modalData: {},
      toggleModal: this.toggleModal,
      isNavOpen: false,
      toggleNavigation: this.toggleNavigation,
      event: false,
      triggerEvent: this.triggerEvent,
      theme: 'default',
      triggerTheme: this.triggerTheme,
      location: 'home',
      setLocation: this.setLocation,
      background: { image: null, style: {}},
      setBackground: this.setBackground,
      checkProgress: false,
      willProgress: this.willProgress,
      didProgress: this.didProgress,
    }
  }

  componentDidMount() {
    this.props.accountActions.getUser()
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.account.isOffline &&
          <div className="Offline-mode">{translate('app.offlineMode')}</div>
        }
        {this.props.account.isLoggedIn &&
          <div className="App">
            <AppParallax />
            <AppDrawer />

            <Switch>
              <Route path={Routes.to('home')} exact  component={Views.Home} />
              <Route path={Routes.to('chapters')}    component={Views.Chapters} />
              <Route path={Routes.to('endtest')}     component={Views.Endtest} />
              <Route path={Routes.to('page')}        component={Views.Page} />
            </Switch>

            <ModalSwitch>
              <Modal name="logout" noclose component={Modals.Logout} />
              <Modal name="help"           component={Modals.Help} />
              <Modal name="summary"        component={Modals.Summary} />
              <Modal name="contract-id"    component={Modals.ContractId} />
              <Modal name="definition-id"  component={Modals.DefinitionId} />
              <Modal name="content-modal"  component={Modals.ContentModal} />
              <Modal name="file-modal"     component={Modals.FileModal} />
              <Modal name="coach-modal"    component={Modals.CoachModal} />
            </ModalSwitch>

            <EventSwitch>
              <Event name="exit" component={Events.Exit} />
            </EventSwitch>
          </div>
        }

        {!this.props.account.isLoggedIn && <Loading done={!this.props.account.isLoading} />}

        <PreloadImages chapters={this.props.chapters} navigation={this.props.navigation} />
      </AppContext.Provider>
    )
  }
}

const PreloadImages = props => (
  <div className="Preloader">
    {props.navigation.map((item, idx) => {
      if(item.chapterId) {
        return <div key={idx} style={{ backgroundImage: `url(${props.chapters.find(chapter => chapter.id === item.chapterId).poster})` }}></div>
      } else {
        return null
      }
    })}
  </div>
)

export default withRouter(connect(
  (state, props) => ({
    account: state.account,
    navigation: state.content.navigation,
    chapters: state.content.chapters,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(App))



// WEBPACK FOOTER //
// ./src/App.js